import type { PaymentProviderError } from 'src/services/helpers/payment'
import { PaymentProvider } from 'src/services/helpers/payment'

export type OnerwayErrorLike = {
  respCode?: string
  respMsg?: string
  data?: unknown
  message?: string
}

export const isOnerwayPaymentError = (
  maybe: any,
): maybe is OnerwayErrorLike & { respCode: string; respMsg: string } =>
  typeof maybe?.respCode === 'string' &&
  typeof maybe?.respMsg === 'string'

export const buildOnerwayError = (
  raw: OnerwayErrorLike,
): PaymentProviderError<PaymentProvider.onerway> =>
  Object.assign(
    new Error(
      typeof raw?.respMsg === 'string'
        ? raw.respMsg
        : typeof raw?.message === 'string'
          ? raw.message
          : "That didn't work out. Please check your payment details and try again.",
    ),
    {
      respCode: raw?.respCode,
      respMsg: raw?.respMsg ?? raw?.message,
      data: raw?.data,
      paymentProvider: PaymentProvider.onerway as const,
      paymentRawError: raw,
    },
  )
